// extracted by mini-css-extract-plugin
export default {"container":"TotalArticles-container_QHG7e"};